<!--<h2 class="text-danger">This feature is currently under development.</h2>-->
<div class="epi-container">
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Origin</label>
            <city-state-zip-dropdown [parentForm]="carrierLaneForm"
                                     [ctrlName]="'originCityControl'"
                                     [placeholder]="'Select a City'"
                                     [cityID]="originCityID"
                                     (citySelected)="laneCitySet($event, 'origin')"
                                     [isChooseDefaultZip]="true"
                                     [isRequired]="true">
            </city-state-zip-dropdown>
        </div>
        <div class="col-sm-3">
            <label class="font-weight-bold">Mode</label>
            <select name="modeID" [(ngModel)]="modeID" class="form-select" (change)="validateForm()">
                <option value="0">Select Mode</option>
                <option *ngFor="let item of modeList" value="{{item.modeID}}">{{item.description}}</option>
            </select>
        </div>
        <div class="col-sm-3">
            <label class="font-weight-bold">Trailer</label>
            <select name="trailerTypeID" [(ngModel)]="trailerTypeID" class="form-select" (change)="validateForm()">
                <option value="0">Select Trailer</option>
                <option *ngFor="let item of trailerTypeList" value="{{item.trailerTypeID}}">{{item.description}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Destination</label>
            <city-state-zip-dropdown [parentForm]="carrierLaneForm"
                                     [ctrlName]="'destinationCityControl'"
                                     [placeholder]="'Select a City'"
                                     [cityID]="destinationCityID"
                                     (citySelected)="laneCitySet($event, 'destination')"
                                     [isChooseDefaultZip]="true"
                                     [isRequired]="true">
            </city-state-zip-dropdown>
        </div>
        <!--<div class="col-sm-3">
            <label class="font-weight-bold">Rate Index</label>
            <select name="rateIndexID" [(ngModel)]="rateIndexID" class="form-select" (change)="validateForm()">
                <option value="0">Select Trailer</option>
                <option *ngFor="let item of rateIndexList" value="{{item.rateIndexID}}">{{item.description}}</option>
            </select>
        </div>-->
        <div class="col-sm-3">
            <input type="checkbox" name="isRoundTrip" [(ngModel)]="isRoundTrip" style="transform:scale(1.5);margin:10px;" (change)="validateForm()" />
            <label class="font-weight-bold" for="isRoundTrip">Round Trip</label>
        </div>
        <div class="col-sm-3">
            <button class="btn btn-primary" (click)="getCarriersByLane()" [disabled]="isValid!=true">Search</button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <kendo-grid #carriersGrid
                        [data]="gridData"
                        [pageSize]="gridState.take"
                        [skip]="gridState.skip"
                        [sort]="gridState.sort"
                        [filter]="gridState.filter"
                        [sortable]="true"
                        [pageable]="true"
                        [filterable]="true"
                        [resizable]="true"
                        (dataStateChange)="dataStateChange($event)">
                <kendo-grid-column field="confidenceRanking" title="Rank" width="35">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <h3 class="badge bg-primary">{{dataItem.confidenceRanking}}</h3>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="source" title="Src" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <strong>{{dataItem.source}}</strong>
                    </ng-template>
                </kendo-grid-column>
                <!--<kendo-grid-column filter="offerRate" title="Rates" width="90">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.offerRate | currency}}<br />
                        {{dataItem.offerRatePerMile | currency}}/mi
                    </ng-template>
                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                        <strong>Rate:</strong> <input [(ngModel)]="dataItem.offerRate" (change)="dataItem.offerRatePerMile=calculateOfferRatePerMile(dataItem.offerRate)" name="offerRate" class="form-control k-input" type="number" step="0.01" /><br />
                        <strong>Rate/mi:</strong> <input [(ngModel)]="dataItem.offerRatePerMile" (change)="dataItem.offerRate=calculateOfferRate(dataItem.offerRatePerMile)" name="offerRatePerMile" class="form-control k-input" type="number" step="0.01" />
                    </ng-template>
                </kendo-grid-column>-->
                <!--<kendo-grid-column title="Contact" width="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <strong>Emailed:</strong> {{dataItem.emailed ? 'Yes' : 'No'}}<br />
                        <strong>Declined:</strong> {{dataItem.declined ? 'Yes' : 'No'}}<br />
                        <strong>Contacted:</strong> {{dataItem.contacted ? 'Yes' : 'No'}}<br />-->
                        <!--<strong>Preferred:</strong> {{dataItem.preferred ? 'Yes' : 'No'}}-->
                    <!--</ng-template>
                    <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                        <strong>Emailed:</strong> <input type="checkbox" [checked]="dataItem.emailed" (change)="dataItem.emailed = !dataItem.emailed" /><br />
                        <strong>Declined:</strong> <input type="checkbox" [checked]="dataItem.declined" (change)="dataItem.declined = !dataItem.declined" /><br />
                        <strong>Contacted:</strong> <input type="checkbox" [checked]="dataItem.contacted||dataItem.offerRate>0||dataItem.offerRatePerMile>0" (change)="dataItem.contacted = !dataItem.contacted" /><br />-->
                        <!--<strong>Preferred:</strong> <input type="checkbox" [checked]="dataItem.preferred" (change)="dataItem.preferred = !dataItem.preferred" />-->
                    <!--</ng-template>
                </kendo-grid-column>-->
                <kendo-grid-column field="carrierName" title="Carrier Name" width="225">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                            {{dataItem.carrierName}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="carrierCode" title="Carrier Code" width="75">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a target="_blank" [routerLink]="['/carrier-detail', dataItem.carrierCode]">
                            {{dataItem.carrierCode}}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="carrierCity" title="City" width="100"></kendo-grid-column>
                <kendo-grid-column field="carrierState" title="State" width="50"></kendo-grid-column>
                <kendo-grid-column field="procurements" title="Cnt" width="50"></kendo-grid-column>
                <kendo-grid-column field="lastOfferRate" title="Last Offer" width="50">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.lastOfferRate | currency}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="extendedRate" title="Last Rate" width="50">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.extendedRate | currency}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="lastRan" title="Last Date" width="75">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.lastRan | date:'shortDate'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="minRate" title="Min Rate" width="50">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.minRate > 0 ? (dataItem.minRate | currency) : ''}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="minRate" title="Min Date" width="75">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.minRate > 0 ? (dataItem.minRateDate | date:'shortDate') : ''}}
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay':isLoading}" *ngIf="isLoading">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
